import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Privacy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background text-text relative">
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-32">
        <button 
          onClick={() => navigate('/')}
          className="flex items-center text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </button>

        <h1 className="text-4xl font-bold mb-8 heading-gradient">Privacy Statement</h1>
        
        <div className="prose prose-invert max-w-none">
          <div className="text-gray-300 mb-8">
            We take your privacy seriously and are committed to protecting your personal information.
            This Privacy Policy explains how Perplexity collects, uses, and protects your information when you use our services.
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">1. Information We May Collect</h2>
            
            <h3 className="text-xl font-semibold mb-3 text-white">1.1 Personal Information</h3>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Name and contact information</li>
              <li>Account credentials</li>
              <li>Billing information</li>
              <li>Company information</li>
              <li>Video conferencing preferences and settings</li>
              <li>Profile pictures and display names</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4 text-white">1.2 Usage Data</h3>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Log data and analytics</li>
              <li>Feature usage statistics</li>
              <li>Performance metrics</li>
              <li>Video conferencing session metadata (duration, participant count)</li>
              <li>Data analytics usage patterns</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">2. Content Data</h2>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Business intelligence and analytics data</li>
              <li>Chat messages during video conferences</li>
              <li>Shared files and documents</li>
              <li>Meeting recordings (when enabled)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>To provide and maintain our Services (Reports Detective and Perplexity Meet)</li>
              <li>To process your transactions</li>
              <li>To improve our Services</li>
              <li>To communicate with you</li>
              <li>To prevent fraud and abuse</li>
              <li>To facilitate video conferencing connections</li>
              <li>To generate analytics and reports</li>
              <li>To provide technical support</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">4. Data Protection</h2>
            <p className="text-gray-300 mb-4">
              We implement industry-standard security measures to protect your data:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>End-to-end encryption for video conferences</li>
              <li>Encryption in transit and at rest for analytics data</li>
              <li>Regular security audits</li>
              <li>Access controls and authentication</li>
              <li>Secure cloud data centers</li>
              <li>Meeting access controls and waiting rooms</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">5. Data Sharing</h2>
            <p className="text-gray-300 mb-4">
              We do not sell your personal information. We may share data with:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Service providers and partners</li>
              <li>Legal authorities when required</li>
              <li>Third parties with your consent</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">6. Your Rights</h2>
            <p className="text-gray-300 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-300 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request data deletion</li>
              <li>Object to data processing</li>
              <li>Export your data</li>
              <li>Control your video conferencing settings</li>
              <li>Manage recording preferences</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-white">7. Contact Information</h2>
            <div className="text-gray-300">
              <p>For privacy-related inquiries, contact us at:</p>
              <div className="mt-4">
                <p>Perplexity</p>
                <p>5851 Legacy Cir</p>
                <p>Plano, Texas 75024</p>
                <p>United States</p>
                <p className="mt-2">Email: info@perplexityonline.com</p>
              </div>
            </div>
          </section>

          <div className="text-gray-400 mt-12 text-sm">
            This Privacy Policy was created in March 2021 and last updated in February 2025. We may update this policy periodically.
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}